export const formatArrivalTime = (departure: moment.Moment, arrival: moment.Moment) => {
  const isSameDay = departure.isSame(arrival, "day");
  const timeDiffInDays = arrival.clone().startOf("day")
    .diff(departure.clone().startOf("day"), "days");
  const sign = timeDiffInDays < 0 ? "" : "+";

  return [isSameDay, timeDiffInDays, sign] as const;
}

const flightDesRegex1 = /^([A-Z0-9]{2})(\d{1,4})$/;
const flightDesRegex2 = /^([A-Z]{3})(\d{1,4})$/;

export const isFlightDesignatorValid = (flightDesignator: string): boolean => {
  if (!flightDesignator || flightDesignator.length < 3 || flightDesignator.length > 7) {
    return false;
  }

  const flightDesignatorParts = getFlightDesignatorParts(flightDesignator);

  return flightDesignatorParts !== null;
}

export const getFlightDesignatorParts = (flightDesignator: string): { airlineCode: string, flightNumber: string } | null => {
  const match1 = flightDesignator.match(flightDesRegex1);
  const match2 = flightDesignator.match(flightDesRegex2);

  if (match2 != null) {
    if (match2[2].replace(/0/g, "").length === 0) {
      return null;
    }

    return {
      airlineCode: match2[1],
      flightNumber: match2[2],
    }
  }

  if (match1 != null) {
    if (!match1[1].match(/[A-Z]/) || match1[2].replace(/0/g, "").length === 0) {
      return null;
    }

    return {
      airlineCode: match1[1],
      flightNumber: match1[2],
    }
  }

  return null;
}

const flightNumberRegex = /^\d{1,4}$/;

export const isFlightNumberOnly = (flightDesignator: string): boolean => {
  return flightNumberRegex.test(flightDesignator);
}

export const getAirportCode = (airport: server.dto.Airport): string =>
  airport.iata || airport.icao || airport.faa;